import * as React from 'react';
import {
  StackLayout,
  HeadingText,
  ParagraphText,
  GDSHeadingLevel,
  GDSHeadingSize,
} from '@leagueplatform/genesis-core';
import { getSubHeadingLevel } from '#utils/get-sub-heading-level.util.ts';
import { TierComponent } from './tier.component';
import type { Tier } from '../plan-usage-widget.types';

interface StaticPlanUsageProps {
  heading?: string;
  headingLevel?: GDSHeadingLevel;
  headingSize?: GDSHeadingSize;
  description?: string;
  tiers?: Tier[];
  onTooltipClick?: (tooltipId: string) => void;
}

export function StaticPlanUsage({
  heading,
  headingLevel: headingLevelProp,
  headingSize = 'md',
  description,
  tiers,
  onTooltipClick: onTooltipClickCallback,
}: StaticPlanUsageProps) {
  const hasHeadingSection = heading || description;
  const headingLevel = React.useMemo(
    () => getSubHeadingLevel(headingLevelProp, '3'),
    [headingLevelProp],
  );
  const tierHeadingLevel = React.useMemo(
    () => (heading ? getSubHeadingLevel(headingLevel) : headingLevel),
    [heading, headingLevel],
  );

  return (
    <StackLayout spacing="$two" css={{ width: '100%' }}>
      {hasHeadingSection && (
        <StackLayout spacing="$threeQuarters">
          {heading && (
            <HeadingText level={headingLevel} size={headingSize}>
              {heading}
            </HeadingText>
          )}

          {description && (
            <ParagraphText size="sm" color="subdued">
              {description}
            </ParagraphText>
          )}
        </StackLayout>
      )}
      {tiers && tiers.length > 0 && (
        <StackLayout spacing="$two" css={{ width: '100%' }}>
          {tiers?.map((tier, tierIndex) => (
            <TierComponent
              key={`tier-${tier.heading?.heading || tierIndex}`}
              heading={tier.heading?.heading}
              headingSize={tier.heading?.headingSize}
              headingLevel={tierHeadingLevel}
              description={tier.description}
              accumulators={tier.accumulators}
              lastUpdated={tier.lastUpdated}
              index={tierIndex}
              onTooltipClick={onTooltipClickCallback}
            />
          ))}
        </StackLayout>
      )}
    </StackLayout>
  );
}
